import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { AutocompleteFilterComponent } from './components/autocomplete-filter/autocomplete-filter.component';
import { DateFilterComponent } from './components/date-filter/date-filter.component';
import { SearchableMultiSelectFilterComponent } from './components/searchable-multi-select-filter/searchable-multi-select-filter.component';
import { SelectFilterComponent } from './components/select-filter/select-filter.component';
import { TextFilterComponent } from './components/text-filter/text-filter.component';
import { ListFilterComponent } from './components/list-filter/list-filter.component';
import { ReadonlyInlineListFilterComponent } from './components/readonly-inline-list-filter/readonly-inline-list-filter.component';
import { DateRangeFilterComponent } from './components/date-range-filter/date-range-filter.component';

@NgModule({
  declarations: [
    ListFilterComponent,
    AutocompleteFilterComponent,
    DateFilterComponent,
    SearchableMultiSelectFilterComponent,
    SelectFilterComponent,
    TextFilterComponent,
    ReadonlyInlineListFilterComponent,
    DateRangeFilterComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [
    ListFilterComponent
  ]
})
export class ListFilterModule { }
